import React, { useState } from 'react';
import {
  FetchBillingAdminsForTransactionAccountPpcQuery,
  FetchBillingAdminsForTransactionAccountPpcQueryVariables,
} from '@css-xp/ppc-graphtypes';
import { ProxyGraphClients, abgGraphqlClient } from '@atlassian/temp-client-utils';
import { downloadAsCSV } from '@css-xp/ppc-utils';
import { fetchBillingAdminsForTransactionAccountPPC } from '../../../../../queries';

export interface UseBillingAdminsCSVProps {
  transactionAccountId: string;
  partnerAccountId: string;
}

export const useBillingAdminsCSV = ({ transactionAccountId, partnerAccountId }: UseBillingAdminsCSVProps) => {
  const [billingAdminsDataLoading, setBillingAdminsDataLoading] = useState(false);

  const ppcBffGraphqlClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.PPC_BFF), []);

  const downloadBillingAdminsCSV = async () => {
    setBillingAdminsDataLoading(true);
    const { data, loading } = await ppcBffGraphqlClient.query<
      FetchBillingAdminsForTransactionAccountPpcQuery,
      FetchBillingAdminsForTransactionAccountPpcQueryVariables
    >({
      query: fetchBillingAdminsForTransactionAccountPPC,
      variables: {
        id: transactionAccountId,
        billingAdminOptions: {
          partnerAccountId,
          billingAdminIds: [],
        },
      },
      notifyOnNetworkStatusChange: true,
    });
    setBillingAdminsDataLoading(loading);
    const billingAdmins = data?.transactionAccount?.billingAdmins?.edges;
    if (billingAdmins) {
      downloadAsCSV({
        fileName: 'billing-admins',
        header: ['Name', 'Email', 'Role'],
        data: billingAdmins.map((node: any) => {
          return [
            node?.node?.fullName ?? '-',
            node?.node?.email ?? '-',
            node?.node?.isPartnerAdmin ? 'Partner Admin' : 'Billing',
          ];
        }),
      });
    }
  };

  return { downloadBillingAdminsCSV, billingAdminsDataLoading };
};
